module.exports = __webpack_public_path__ + "static/media/50_Print.739a3a39.png";